export default class Navigation {
  static selectorString() {
    return '.Navigation';
  }

  constructor(rootNode) {
    this.burgerIcon = rootNode.querySelector('.burger-icon');
    this.burgerIcon.addEventListener('click', this.toggleNav.bind(this));
    Navigation.buildMobileNav();
  }

  toggleNav() {
    document.body.classList.toggle('menu-open');
    if (document.body.classList.contains('menu-open')) {
      this.burgerIcon.classList.add('open');
    } else {
      this.burgerIcon.classList.remove('open');
    }
  }

  static buildMobileNav(menuItems) {
    jQuery(document).ready(function() {
      jQuery(
        '<div id="MobileNavigation" class="MobileNavigation"><ul class="navigation"></ul></div>').
        appendTo('body');
      const mainmenu = jQuery('.Navigation .desktop-menu ul').clone();
      jQuery('#MobileNavigation').html(mainmenu);
    });
  }
}
